class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
const cartRemoveId = this.getAttribute('cart-remove-id');
     // alert(`Removing variant ID: ${cartRemoveId}`);

            const giftInput = document.getElementById('master-free-gift');
      const giftId = giftInput.getAttribute('data-giftid');
     

      const dateProductId = giftInput.getAttribute('date-productid');
const productIdList = dateProductId.split(',').map(id => id.trim()).filter(Boolean);
      

      if (productIdList.includes(cartRemoveId)) {
  const giftRemoveButton = document.querySelector(`cart-remove-button[cart-remove-id="${giftId}"]`);

  if (giftRemoveButton) {
    const anchor = giftRemoveButton.querySelector('a[href*="/cart/change?id="]');
    
    if (anchor) {
      const href = anchor.getAttribute('href');
   //   alert(href);

      fetch(href)
        .then(response => {
          if (!response.ok) throw new Error('Failed to remove product from cart');
          // location.reload(); // Optional
        })
        .catch(error => {
          console.error('Fetch error:', error);
        });
    }
  }
} else {
      
      }
   setTimeout(() => {
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      
      if (this.dataset.type === 'Ordered') {

        if (parseInt(this.dataset.redeem) > 0) {

          if (window.location.pathname === '/cart') {
 document.querySelector('.error_display_text').innerHTML = 'To remove this item, first remove the selected gifts from your basket.';
      document.querySelector('.error_display').classList.add('active');
  } else {  
document.querySelector('.error-text-icon p').innerHTML = 'To remove this item, first remove the selected gifts from your basket.';
      document.querySelector('.error-redeem-points').classList.add('active');
                const cartItemsContainer = document.querySelector('.cart-drawer cart-drawer-items');
if (cartItemsContainer) {
//  cartItemsContainer.scrollTop = 0;
}
      cartItemsContainer.scrollTo({
  top: 0,
  behavior: 'smooth'
});

          }
          cartItems.updateQuantity(this.dataset.index, 0);
      return;
} else {
          cartItems.updateQuantity(this.dataset.index, 0);
}
} else {

        cartItems.updateQuantity(this.dataset.index, 0);
}

     }, 2000);    
    });
  
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    const maxi = event.target.dataset.maxi;
    let message = '';


   
    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
     
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          // Call initializeFlickity after the cart content has been updated
        initializeFlickity();
            document.body.classList.add('checkout_btn_load');
    shipData();
            document.querySelectorAll('[cart-var-id]').forEach(elmadd => {
  const varIdsadd = elmadd.getAttribute('cart-var-id');
  const sectionsadd = elmadd.getAttribute('cart-section') || '';

  alertVariant(varIdsadd, sectionsadd, 'https://roollapius.korres.com');


});

                     document.querySelectorAll('[mcart-var-id]').forEach(elmainr => {
  const varIdsadd = elmainr.getAttribute('mcart-var-id');
  const sectionsadd = elmainr.getAttribute('cart-section') || '';

  alertVariant(varIdsadd, sectionsadd, 'https://roollapius.korres.com');


});

                document.querySelectorAll('.carousel-cell-fav').forEach(elmaddr => {
  const varIdsaddr = elmaddr.getAttribute('data-var-id');

  alertVariant(varIdsaddr, "favorite", 'https://roollapius.korres.com');


});
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
     //alert('already in cart ')
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    // Ensure initializeFlickity is also called outside of the fetch to be safe
  initializeFlickity();

       document.body.classList.add('checkout_btn_load');
    shipData();
                document.querySelectorAll('[cart-var-id]').forEach(elmadd => {
  const varIdsadd = elmadd.getAttribute('cart-var-id');
  const sectionsadd = elmadd.getAttribute('cart-section') || '';

  alertVariant(varIdsadd, sectionsadd, 'https://roollapius.korres.com');


});

               document.querySelectorAll('.carousel-cell-fav').forEach(elmaddr => {
  const varIdsaddr = elmaddr.getAttribute('data-var-id');

  alertVariant(varIdsaddr, "favorite", 'https://roollapius.korres.com');


});
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        var cart_qty = parsedState.item_count;
        console.log('current_qty',cart_qty);
        if (cart_qty === 0) {
            const relatedHeading = document.querySelector('.related-products__heading.inline-richtext.h2');
            if (relatedHeading) {
                relatedHeading.textContent = 'Trending Now';
            }
        } 
        
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        // Call initializeFlickity after the cart is updated
      initializeFlickity();
            document.body.classList.add('checkout_btn_load');
    shipData();
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);

document.querySelectorAll('[cart-var-id]').forEach(elm => {
  const varId = elm.getAttribute('cart-var-id');
  const section = elm.getAttribute('cart-section') || '';

  alertVariant(varId, section, 'https://roollapius.korres.com');


});

        document.querySelectorAll('[mcart-var-id]').forEach(elmain => {
  const varId = elmain.getAttribute('mcart-var-id');
  const section = elmain.getAttribute('cart-section') || '';

  alertVariant(varId, section, 'https://roollapius.korres.com');


});

             document.querySelectorAll('.carousel-cell-fav').forEach(elmaddr => {
  const varIdsaddr = elmaddr.getAttribute('data-var-id');

  alertVariant(varIdsaddr, "favorite", 'https://roollapius.korres.com');


});
        
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
